import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

import Icon from '../Icon/Icon';

const navigation = ( props ) => {
	let navClass = 'SideNav';
	if( props.horizontal ) {
		navClass = 'RowNav';
	}
	
	const navButtons = [
		{
			title: 'About Our Company',
			id: 'about',
			url: 'about-our-company'
		},
		{
			title: 'The Almighty Dollar',
			id: 'pay',
			url: 'the-almighty-dollar'
		},
		{
			title: 'Super Tech Support',
			id: 'it',
			url: 'super-tech-support'
		},
		{
			title: 'Perks for the People',
			id: 'benefits',
			url: 'perks-for-the-people'
		},
		{
			title: 'Collaborate & Listen',
			id: 'communication',
			url: 'collaborate-and-listen'
		}
	]
	
	return (
		<nav className={ navClass }>
			{
				navButtons.map( button => (
					<NavLink key={ button.id } to={ '/' + button.url } exact>
						<div>
							<Icon icon={ 'navigation.' + button.id } className="navButton" gradient="vertical" title={ button.title } />
							<span className="navTitle">{ button.title }</span>
						</div>
					</NavLink>
				))
			}
		</nav>
	);
};

export default navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js